import { Component, OnInit } from '@angular/core';
import { ProviderParameters, BankDetailParameters } from 'src/app/models/ui/ProviderParameters';
import { HelperService } from 'src/app/services/Helper/helper.service';
import { LookupService } from 'src/app/services/Lookup/lookup.service';
import { Subject } from 'rxjs';
import { RegistrationService } from '../../services/registration.service';
import { User } from 'src/app/models/ui/User';
import { Guid } from 'guid-typescript';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})

export class RegistrationComponent implements OnInit {
  public providerParameters: ProviderParameters;
  eventsSubject: Subject<ProviderParameters> = new Subject<ProviderParameters>();
  captchaImage: string | ArrayBuffer | null = null;

  public userParameters: User;
  public bankDetailParameters: BankDetailParameters;

  public countryId: number;
  public roleId: number;
  public typeId: number;
  captchaText: string;
  contractTypes: any[];
  roles: any[];
  status: any[];
  countries: any[];

  userRegex: any;
  emailRegex: any;
  phoneRegex: any;

  byteDoc: any;

  loadingVisible = false;
  captchaId: string;
  constructor(private helper: HelperService, private registrationService: RegistrationService, private lookupService: LookupService) {
    this.providerParameters = new ProviderParameters();
    this.userParameters = new User();
    this.bankDetailParameters = new BankDetailParameters();
    this.captchaId = Guid.create().toString();
  }

  refreshCaptcha(): void {
    this.registrationService.generateCaptcha(this.captchaId).subscribe(
      (response: ArrayBuffer) => {
        const base64String = this.arrayBufferToBase64(response);
        this.captchaImage = 'data:image/jpeg;base64,' + base64String;
      },
      (error) => {
        console.log('Error refreshing captcha:', error);
      }
    );
  }
  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
  ngOnInit() {
    this.helper.setTitle('Provider - Create Provider');
    this.refreshCaptcha();
    this.lookupService.getContractTypes().subscribe(data => this.contractTypes = data);
    this.lookupService.getRoles().subscribe(data => this.roles = data);
    this.lookupService.getStatus().subscribe(data => this.status = data);
    this.lookupService.getCountries().subscribe(data => this.countries = data);
    this.bankDetailParameters.BankLetter = [];
    this.byteDoc = [];

    setTimeout(() => {
      this.explore();
    }, 100);
  }

  explore() {
    this.eventsSubject.next(this.providerParameters);
  }

  selectCountry(e) {
    this.countryId = e.value;
  }

  selectType(e) {
    this.typeId = e.value;
  }

  resetParameters() {
    this.providerParameters = new ProviderParameters();
    this.bankDetailParameters = new BankDetailParameters();
  }

  registerProvider() {
    if (!this.captchaText) {
      return alert("Please Fill Captcha Text")
    }
    this.byteDoc = localStorage.getItem("document");

    if (this.byteDoc == null) {
      alert("Please upload your bank letter before proceeding");
    }
    else {
      this.loadingVisible = true;

      this.userRegex = new RegExp("^[a-zA-Z0-9.]+$");
      this.emailRegex = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$");
      this.phoneRegex = new RegExp("^[0-9]{0,12}$");

      if (!this.userParameters.UserName.match(this.userRegex)) {
        alert("Your username contains invalid characters. Please use only alphanumeric characters and dots.");
        document.getElementById("userNameBox").style.backgroundColor = "crimson";
        if (!this.userParameters.Email.match(this.emailRegex)) document.getElementById("emailBox").style.backgroundColor = "crimson";
        if (!this.userParameters.PhoneNumber.match(this.phoneRegex)) document.getElementById("phoneNumberBox").style.backgroundColor = "crimson";
        this.loadingVisible = false;
        return;
      }

      if (!this.userParameters.Email.match(this.emailRegex)) {
        alert("Your email contains invalid characters.");
        document.getElementById("emailBox").style.backgroundColor = "crimson";
        if (!this.userParameters.PhoneNumber.match(this.phoneRegex)) document.getElementById("phoneNumberBox").style.backgroundColor = "crimson";
        this.loadingVisible = false;
        return;
      }

      if (!this.userParameters.PhoneNumber.match(this.phoneRegex)) {
        alert("Your phone number contains invalid characters. Please follow the correct number format.");
        document.getElementById("phoneNumberBox").style.backgroundColor = "crimson";
        this.loadingVisible = false;
        return;
      }

      if (this.bankDetailParameters.AccountNumber == null
        || this.bankDetailParameters.Name == null
        || this.bankDetailParameters.IBAN == null
        || this.bankDetailParameters.SwiftCode == null
        || this.bankDetailParameters.BankLetter == null
        || this.bankDetailParameters.BankLetter == []) {
        alert("Please complete your bank details before proceeding.");
        this.loadingVisible = false;
        return;
      }

      this.providerParameters.CountryId = this.countryId;
      this.providerParameters.RoleId = this.roleId;
      this.providerParameters.TypeId = this.typeId;
      this.providerParameters.DisplayName = this.userParameters.UserName;
      this.providerParameters.FirstName = this.userParameters.FirstName;
      this.providerParameters.LastName = this.userParameters.LastName;
      this.providerParameters.Email = this.userParameters.Email;
      this.providerParameters.PhoneNumber = this.userParameters.PhoneNumber;
      this.bankDetailParameters.BankLetter = this.byteDoc.substring(this.byteDoc.indexOf("base64,") + 7);
      this.providerParameters.BankDetails = this.bankDetailParameters;

      setTimeout(() => {
        this.registrationService.registerProvider(this.providerParameters, this.captchaText, this.captchaId).subscribe(data => this.displayResult(data));
      }, 5000);

      localStorage.removeItem("document");

      document.getElementById("userNameBox").style.backgroundColor = "white";
      document.getElementById("emailBox").style.backgroundColor = "white";
      document.getElementById("phoneNumberBox").style.backgroundColor = "white";
    }
  }

  onValueChanged(e) {
    const reader = new FileReader();
    reader.readAsDataURL(e.value[0]);
    reader.onload = function () {
      const data = reader.result;
      setTimeout(() => {
        const byteDoc = [];
        byteDoc.push(data);
        localStorage.setItem("document", byteDoc.toString());
      }, 2000);
    }
  }

  displayResult(data) {
    this.loadingVisible = false;
    alert(data);
  }
}